/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */


import { useAppSelector } from '@reducers/index';
import { getCurrentUser } from '@selectors/user';

export const useCurrentUser = () => {
  const user = useAppSelector(getCurrentUser)
  if (!user) {
    throw new Error('User must be authenticated');
  }

  return user;
}
